import { useCmsNew, type CmsNewKey } from "@/lib/cms/cms-new-i18n";
import { Label } from "@/components/ui/label";
import { CMS_PALETTE_TEXT_INPUT_CLASS } from "@/components/cms/theme/cms-color-input-styles";
import { cn } from "@/lib/utils";
import {
  type BlockSpacingBox,
  type SpacingSide,
  type SpacingUnit,
} from "@/lib/cms-puck/block-style";
import { StyleSection } from "./StyleSection";

export const SPACING_UNITS: SpacingUnit[] = ["px", "rem", "em", "%"];

const SIDE_LABELS: Array<[keyof BlockSpacingBox, CmsNewKey, string]> = [
  ["top", "cms.new.auto.option.top.haut", "Haut"],
  ["right", "cms.new.auto.option.right.droite", "Droite"],
  ["bottom", "cms.new.auto.option.bottom.bas", "Bas"],
  ["left", "cms.new.auto.option.left.gauche", "Gauche"],
];

export function SpacingBoxEditor({
  title,
  description,
  box,
  onChange,
  placeholders,
}: {
  title: string;
  description?: string;
  box: BlockSpacingBox;
  onChange: (box: BlockSpacingBox) => void;
  /** Valeurs héritées affichées en placeholder (vue tablette/mobile). */
  placeholders?: BlockSpacingBox;
}) {
  const cmsNew = useCmsNew();
  return (
    <StyleSection title={title} description={description}>
      {/* 2 colonnes : inputs assez larges pour lire la valeur (cf. radius). */}
      <div className="grid grid-cols-2 gap-3">
        {SIDE_LABELS.map(([side, key, fallback]) => {
          const label = cmsNew(key, fallback);
          return (
            <div key={side} className="space-y-1.5">
              <Label
                htmlFor={`spacing-${side}`}
                className="text-xs font-medium text-slate-500"
              >
                {label}
              </Label>
            <input
              id={`spacing-${side}`}
              type="number"
              value={box[side] ?? ""}
              placeholder={
                placeholders?.[side] != null
                  ? String(placeholders[side])
                  : "0"
              }
              className={cn(CMS_PALETTE_TEXT_INPUT_CLASS, "h-9 text-center tabular-nums")}
              onChange={(e) => {
                const raw = e.target.value;
                const next: SpacingSide = raw === "" ? null : Number(raw);
                onChange({
                  ...box,
                  [side]: next != null && Number.isFinite(next) ? next : null,
                });
              }}
            />
            </div>
          );
        })}
      </div>
    </StyleSection>
  );
}
